//Реакт
import React from "react";
//Стили
import "./styles.css";

export default function ContentLoader(){
  return <div className="content__loader">
    <div className="content__loader-icon"><div></div><div></div><div></div><div></div></div>
  </div>
}